// Shared by theme cart updates and the Slide Cart drawer.
window.updateHeaderCartCount = function (cart) {
  if (!cart || !Array.isArray(cart.items)) return;

  var count = cart.items.reduce(function (total, item) {
    var properties = item.properties || {};
    var isPricingItem = (properties._pc_pricing_ref && properties._pc_pricing_qty_split == null) ||
      (properties._pplr_pricing_ref && properties._pplr_pricing_qty_split == null);
    return total + (isPricingItem || item.product_type === 'PPLR_HIDDEN_PRODUCT' ? 0 : item.quantity);
  }, 0);

  document.querySelectorAll('[data-cart-count]').forEach(function (badge) {
    badge.textContent = count;
    badge.classList.toggle('is-hidden', count === 0);
  });
};
